// Single source of truth for upcoming shows.
// Add shows here, in any order. The site auto-sorts them by end_date,
// drops anything already past, promotes the next one in line to the
// "featured" / next event spot, and lists the rest under "Also coming up".
//
// end_date MUST be YYYY-MM-DD (last day of the event — the show stays
// listed through that whole day in local time and disappears the next
// morning).

export const SHOWS = [
  {
    slug: "nerd-expo-oct",
    name: "Nerd Expo — Red Deer",
    end_date: "2026-10-18",
    dates: "Oct 17–18, 2026",
    location: "Westerner Park, Red Deer, AB",
    link: "https://www.nerdexpo.ca",
    image_url:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_tcg-live-queue/artifacts/o1132s0v_Nerd-Expo-Oct-FB-Banner.jpg",
    cta: "Event details",
    badge: "Live IRL event",
    blurb: "Come find us at the booth — cards, sealed and hand-picked singles.",
  },
  {
    slug: "premier-card-event-oct",
    name: "Premier Card & Collectibles Convention",
    end_date: "2026-11-01",
    dates: "Oct 31 – Nov 1, 2026",
    location: "Prairie Pavilion, Red Deer",
    link: "",
    image_url:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_tcg-live-queue/artifacts/2549e40fc77abea1_842143480_122143962537106190_4656970392197182673_n.jpg",
    cta: "Event details",
    badge: "Halloween weekend",
    blurb: "Come find us at the booth — cards, sealed and hand-picked singles.",
  },
];

/**
 * Returns { featured, upcoming } where:
 *  - featured = the next show that hasn't passed yet (or null)
 *  - upcoming = every other future show, sorted by end_date ascending
 * A show is considered "past" when its end_date is strictly before today.
 */
export function getShowSchedule(now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const future = SHOWS
    .filter((s) => {
      if (!s.end_date) return true; // treat undated shows as always upcoming
      const [y, m, d] = s.end_date.split("-").map((n) => parseInt(n, 10));
      const end = new Date(y, m - 1, d);
      return end >= today;
    })
    .sort((a, b) => (a.end_date || "").localeCompare(b.end_date || ""));

  return {
    featured: future[0] || null,
    upcoming: future.slice(1),
  };
}
